"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_h5_audio_player_1 = __importDefault(require("react-h5-audio-player"));
require("react-h5-audio-player/lib/styles.css");
function Audio(props) {
    const { src } = props;
    return ((0, jsx_runtime_1.jsx)(react_h5_audio_player_1.default, { autoPlay: false, src: src }));
}
exports.default = Audio;
